export function reviewSliderInit(target = '.farlo-ui-reviews__list', options = {}, buttonPosition = 'below') {
  // Allow passing a selector string or an element
  const slider = typeof target === 'string' ? document.querySelector(target) : target;
  if (!slider) return null;

  const defaultOptions = {
    cellAlign: 'center',
    contain: true,
    pageDots: false,
    wrapAround: true,
    autoPlay: 5000,
    prevNextButtons: true,
    adaptiveHeight: true,
    ...options
  };

  // Create Flickity first so buttons exist
  const flkty = new Flickity(slider, defaultOptions);

  if (buttonPosition === 'below') {
    const prevBtn = slider.querySelector('.flickity-button.previous');
    const nextBtn = slider.querySelector('.flickity-button.next');

    if (prevBtn && nextBtn) {
      const wrapper = document.createElement('div');
      wrapper.className = 'site__wrapper';
      // move the buttons into the wrapper, placed before the first one
      prevBtn.parentElement.insertBefore(wrapper, prevBtn);
      wrapper.appendChild(prevBtn);
      wrapper.appendChild(nextBtn);
    }
  }

  return flkty;
}


